// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","455":"c102001d","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};